import { useEffect, useRef, useState } from "react";
import uuid from "uuid";
import axios from "axios";

export const sleep = (ms) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, ms);
  });
};

const objectToParams = (obj) => {
  return Object.keys(obj)
    .map((key) => key + "=" + encodeURIComponent(obj[key]))
    .join("&");
};

export default (onImageUploaded, onComplete) => {
  const value = "";
  const [retrying, setRetrying] = useState(false);
  const [queue, setQueue] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [fileProgress, setFileProgress] = useState(0);
  const [totalProgress, setTotalProgress] = useState(0);

  const queueRef = useRef();
  queueRef.current = queue;

  useEffect(() => {
    if (isUploading) {
      return;
    }
    if (queue.length > 0) {
      upload();
    }
  }, [queue]);

  const updateUploadStatus = (item, status) => {
    setQueue((queue) => {
      return queue.map((i) => {
        if (i.uuid == item.uuid) {
          return {
            ...i,
            status,
          };
        }
        return i;
      });
    });
  };

  const progressCallback = (pe) => {
    setFileProgress(pe.loaded / pe.total);

    // Total files:
    const totalFileSize = queue.reduce((sum, i) => sum + i.image.size, 0);
    const completedSize =
      queueRef.current
        .filter((item) => item.status == 2)
        .reduce((sum, i) => sum + i.image.size, 0) + pe.loaded;

    setTotalProgress(completedSize / totalFileSize);
  };

  const upload = async () => {
    setIsUploading(true);
    const files = [];
    let allUploaded = true;
    for (const item of queue) {
      updateUploadStatus(item, 1);
      let fileWasUploaded = false;
      for (let i = 0; i < 5; i++) {
        try {
          setFileProgress(0);
          setRetrying(false);
          const response = await uploadImageType(
            item.image,
            "template",
            progressCallback,
          );
          if (response.result == "OK") {
            updateUploadStatus(item, 2);
            if (onImageUploaded) {
              onImageUploaded(response.files[0]);
            }
            files.push(response.files[0]);
            fileWasUploaded = true;
            break;
          } else {
            // Can we do anything here?
          }
        } catch (err) {
          console.log("Error upload", err);
        }
        setRetrying(true);
        await sleep(5000);
      }

      if (!fileWasUploaded) {
        allUploaded = false;
        updateUploadStatus(item, -1);
      }
    }

    if (onComplete) {
      onComplete(files, allUploaded);
    }
    setIsUploading(false);
    setQueue([]);
  };

  const addImages = (e) => {
    const arrFiles = Array.from(e.target.files);
    const images = arrFiles.filter((file) => file.type.startsWith("image"));

    const items = images.map((image) => {
      return {
        image,
        status: 0,
        uuid: uuid.v4(),
      };
    });

    // We no longer support adding to queue, we want to know when it's done: (Gui need lock)
    setQueue(items);
  };

  return {
    isUploading,
    fileProgress,
    totalProgress,
    retrying,
    bind: {
      value,
      accept: "image/*",
      onChange: addImages,
    },
  };
};

const uploadImageType = (image, type, progressCallback) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("images[]", image);

    const params = {
      handleuploads: true,
      interface: "HTML",
      redirect: "/",
      uploadtype: type,
      json: true,
      thumbnails: 640,
    };

    const queryString = objectToParams(params);

    axios
      .request({
        method: "post",
        url: "/system/iframes/upload_internal.php?" + queryString,
        data: formData,
        onUploadProgress: progressCallback,
      })
      .then((data) => resolve(data.data))
      .catch((error) => reject(error));
  });
};
